<template>
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/more/blk">
      <g id="icon/more/blk_2">
        <g id="&#231;&#188;&#150;&#231;&#187;&#132;">
          <path
            id="Stroke 1"
            d="M4.5 12.291H20.162"
            stroke="currentcolor"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            id="Stroke 3"
            d="M20.1254 12.291C16.9264 12.291 14.3345 9.69904 14.3345 6.5"
            stroke="currentcolor"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            id="Stroke 5"
            d="M20.1254 12.291C16.9264 12.291 14.3345 14.883 14.3345 18.082"
            stroke="currentcolor"
            stroke-width="2"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts" setup></script>

<style></style>
